<template>
  <div>
    <!--Information Pane-->
    <div class="information" v-if="signature != null">
      <div class="title">
        <h4>{{ 'İmza Detayları'|trans }}</h4>
        <button class="close" @click="signature = null"><i class="fas fa-times"></i></button>
      </div>
      <div class="details">
        <!--Signature Details-->
        <div class="item"><span class="type">{{ 'Uygulama Sürümü:'|trans }}</span><span class="value">{{ signature.appVersion }}</span></div>
        <div class="item"><span class="type">{{ 'Url Adresi:'|trans }}</span><span class="value">{{ signature.baseUrl }}</span></div>
        <div class="item"><span class="type">{{ 'İmza Tarihi:'|trans }}</span><span class="value">{{ signature.signedAt }}</span></div>
        <div class="item"><span class="type">{{ 'Konum:'|trans }}</span><a class="value" href="#!" @click="viewLocation(signature.location)">
          {{ 'Haritada Gör'|trans }}</a></div>
        <div class="item"><span class="type">{{ 'Mesafe:'|trans }}</span><span class="value">{{ signature.location.diameter }}</span></div>
        <div class="item"><span class="type">{{ 'İmza Tipi:'|trans }}</span><span class="value">{{ signature.drawer }}</span></div>
        <div class="item"><span class="type">{{ 'İmzalayan:'|trans }}</span><span class="value">{{ signature.userName }}</span></div>
        <div class="item"><span class="type">{{ 'E-posta Adresi:'|trans }}</span><span class="value">{{ signature.userEmail }}</span></div>
        <div class="item"><span class="type">{{ 'Cihaz Modeli:'|trans }}</span><span class="value">{{ signature.deviceInfo.name }}</span></div>
        <div class="item"><span class="type">{{ 'Cihaz IMEI:'|trans }}</span><span class="value">{{ signature.deviceInfo.imei }}</span></div>

        <!--Identity Details-->
        <template v-if="signature.identityData && signature.identityData.user">
          <div class="item border-top pt-3 align-items-start">
            <span class="type">{{ 'Kimlik Bilgileri:'|trans }}</span>
            <span class="value"><img v-if="signature.identityData.user.userPhotoBase64" :src="'data:image/png;base64,'+signature.identityData.user.userPhotoBase64"></span>
          </div>
          <div class="item"><span class="type">{{ 'İsim:'|trans }}</span><span class="value">{{ signature.identityData.user.name }}</span></div>
          <div class="item"><span class="type">{{ 'Kimlik No:'|trans }}</span><span class="value">{{ signature.identityData.user.personalNumber }}</span></div>
          <div class="item"><span class="type">{{ 'Kart Numarası:'|trans }}</span><span class="value">{{ signature.identityData.user.cardNumber }}</span></div>
          <div class="item"><span class="type">{{ 'Doğum Tarihi:'|trans }}</span><span class="value">{{ signature.identityData.user.dateOfBirth }}</span></div>
          <div class="item"><span class="type">{{ 'Belge Kodu:'|trans }}</span><span class="value">{{ signature.identityData.user.documentCode }}</span></div>
          <div class="item"><span class="type">{{ 'Belge No:'|trans }}</span><span class="value">{{ signature.identityData.user.documentNumber }}</span></div>
          <div class="item"><span class="type">{{ 'Son Kullanım:'|trans }}</span><span class="value">{{ signature.identityData.user.expiryDate }}</span></div>
          <div class="item"><span class="type">{{ 'Cinsiyet:'|trans }}</span><span class="value">{{ signature.identityData.user.gender }}</span></div>
          <div class="item"><span class="type">{{ 'Doğrulanmış:'|trans }}</span><span class="value">{{ signature.identityData.user.isContentValid }}</span></div>
        </template>
      </div>
    </div>

    <!--Location Modal-->
    <div class="modal fade" id="locationModal" tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body d-flex p-0"><div id="locationMap"></div></div>
          <div class="modal-footer p-2">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'Kapat'|trans }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignatureDetails",

  data: () => {
    return {
      signature: null
    }
  },

  methods: {
    /**
     * Open Information Panel
     *
     * @param signature
     */
    show(signature) {
      this.signature = signature;
    },

    /**
     * Show Location Modal
     */
    viewLocation(location) {
      // Show Modal
      $('#locationModal').modal('toggle')

      setTimeout(() => {
        // Create Map
        if (!this.map) {
          this.map = L.map('locationMap');
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          }).addTo(this.map);
        }

        // Reset Map
        this.map.eachLayer((layer) => {
          if (!layer._url) this.map.removeLayer(layer)
        });

        // Center Maps to Lat - Long
        this.map.setView([location.latitude, location.longitude], 15);

        // Add Marker & Circle
        L.marker([location.latitude, location.longitude]).addTo(this.map);
        if (location.diameter) {
          L.circle([location.latitude, location.longitude], {
            color: 'red',
            fillColor: '#f03',
            fillOpacity: 0.3,
            radius: location.diameter.replace( /[^\d\.]*/g, '')
          }).addTo(this.map);
        }
      }, 400)
    }
  }
}
</script>

<style lang="scss">
#locationMap {
  width: 100%;
  height: 450px;
}
</style>
